import type { ReactNode } from 'react';

export type TArticleBountyBoardProps = {
  eventSlug: string;
  bountySlug?: string;
  compact?: boolean;
};

export type TArticleBountyBoardRenderer = (props: TArticleBountyBoardProps) => ReactNode;

let articleBountyBoardRenderer: TArticleBountyBoardRenderer | null = null;

export function setArticleBountyBoardRenderer(renderer: TArticleBountyBoardRenderer | null) {
  articleBountyBoardRenderer = renderer;
}

export function getArticleBountyBoardRenderer(): TArticleBountyBoardRenderer | null {
  return articleBountyBoardRenderer;
}
